import React, { useState } from "react";
import "../DashboardStyles.css";

// ─── Data ────────────────────────────────────────────────────────────────────

const SOURCES = [
  { agency: "U.S. Census Bureau", title: "American Community Survey (ACS) 5-Year Estimates", url: "https://data.census.gov" },
  { agency: "USDA National Agricultural Statistics Service (NASS)", title: "2022 Census of Agriculture", url: "https://www.nass.usda.gov" },
  { agency: "U.S. Bureau of Economic Analysis (BEA)", title: "Regional Economic Information System", url: "https://apps.bea.gov/regional" },
  { agency: "U.S. Geological Survey (USGS)", title: "High Plains Aquifer and groundwater resources data and publications", url: "https://www.usgs.gov" },
  { agency: "Nebraska Association of Resources Districts (NARD)", title: "Natural Resources District information and water-management resources", url: "https://www.nrdnet.org" },
  { agency: "North Platte NRD; Twin Platte NRD; Upper Niobrara-White NRD", title: "District water-management and groundwater resources" },
  { agency: "U.S. Bureau of Labor Statistics", title: "Quarterly Census of Employment and Wages (QCEW)", url: "https://www.bls.gov/cew" },
  { agency: "U.S. Bureau of Labor Statistics", title: "Local Area Unemployment Statistics (LAUS)", url: "https://www.bls.gov/lau" },
  { agency: "Federal Highway Administration", title: "National Bridge Inventory (NBI)", note: "Data date 3/13/2025" },
  { agency: "Nebraska Department of Transportation", title: "FY 2026–2029 STIP, Amendment 4", note: "Approved February 2, 2026" },
  { agency: "Nebraska Department of Transportation", title: "Bridge Condition Report — Locally Owned Bridges", note: "Data date 3/13/2025" },
  { agency: "Federal Aviation Administration", title: "Airport Master Record, Western Nebraska Regional Airport (BFF)", note: "Effective February 24, 2026" },
  { agency: "Nebraska Broadband Office", title: "BEAD Five-Year Action Plan", note: "August 2023" },
  { agency: "Nebraska Broadband Office", title: "NTIA BEAD approval press release", note: "January 14, 2025" },
  { agency: "Nebraska Broadband Office", title: "NBO Subgrant Agreements press release", note: "May 22, 2026", url: "https://dot.nebraska.gov/media/xvllowbe/20260522-nbo-subgrantagreements.pdf" },
  { agency: "Light Reading", title: "Ferraro, Nicole. “Nebraska to reopen BEAD bids after providers drop out.”", note: "May 26, 2026", url: "https://www.lightreading.com" },
  { agency: "Nebraska Public Media", title: "Bamer, Erin. “Future of Nebraska Broadband Office unclear following reduction in federal BEAD funds.”", note: "May 4, 2026", url: "https://nebraskapublicmedia.org" },
  { agency: "National Park Service", title: "2023 Visitor Spending Effects Report" },
  { agency: "Health Resources and Services Administration (HRSA)", title: "HPSA Designation Data", url: "https://data.hrsa.gov" },
  { agency: "Centers for Medicare and Medicaid Services (CMS)", title: "Critical Access Hospital Certification List" },
  { agency: "Nebraska Travel Association / Nebraska Tourism Commission", title: "February 2026 press release", note: "BEA tourism GDP data, 2023–2024" },
  { agency: "USDA Economic Research Service", title: "County Typology Codes", url: "https://www.ers.usda.gov" },
  { agency: "Nebraska Oil and Gas Conservation Commission (NOGCC)", title: "Oil and gas production data", url: "https://nogcc.ne.gov" },
  { agency: "Nebraska Department of Environment and Energy (NDEE)", title: "Energy statistics" },
  { agency: "Panhandle Area Development District", title: "Nebraska Panhandle Community Survey", note: "March–May 2026 (N=203)" },
  { agency: "Heartland Center for Leadership Development with Career Connections of Western Nebraska / ESU 13", title: "Western Nebraska Teen Opportunities Survey", note: "October 2023 (N=3,826)" },
  { agency: "Panhandle Area Development District", title: "CEDS Strategy Council application responses", note: "Spring 2026 (N=7)" },
];

const ACRONYMS = [
  { abbr: "6R1N",   def: "6 Regions 1 Nebraska (regional development network)" },
  { abbr: "ACS",    def: "American Community Survey (U.S. Census Bureau)" },
  { abbr: "BEA",    def: "Bureau of Economic Analysis" },
  { abbr: "BEAD",   def: "Broadband Equity, Access, and Deployment Program (NTIA)" },
  { abbr: "CAH",    def: "Critical Access Hospital" },
  { abbr: "CAPWN",  def: "Community Action Partnership of Western Nebraska" },
  { abbr: "CCDBG",  def: "Childcare and Development Block Grant" },
  { abbr: "CDBG",   def: "Community Development Block Grant" },
  { abbr: "CEDS",   def: "Comprehensive Economic Development Strategy" },
  { abbr: "CSC",    def: "Chadron State College" },
  { abbr: "DED",    def: "Nebraska Department of Economic Development" },
  { abbr: "EDA",    def: "Economic Development Administration (U.S. Department of Commerce)" },
  { abbr: "HPSA",   def: "Health Professional Shortage Area (HRSA designation)" },
  { abbr: "IIJA",   def: "Infrastructure Investment and Jobs Act" },
  { abbr: "IRA",    def: "Inflation Reduction Act" },
  { abbr: "MOE",    def: "Margin of Error" },
  { abbr: "MUA",    def: "Medically Underserved Area" },
  { abbr: "NACO",   def: "Nebraska Association of County Officials" },
  { abbr: "NBDC",   def: "Nebraska Business Development Center" },
  { abbr: "NDE",    def: "Nebraska Department of Education" },
  { abbr: "NDEE",   def: "Nebraska Department of Environment and Energy" },
  { abbr: "NDOL",   def: "Nebraska Department of Labor" },
  { abbr: "NDOT",   def: "Nebraska Department of Transportation" },
  { abbr: "NETA",   def: "Nebraska Travel Association" },
  { abbr: "NHSC",   def: "National Health Service Corps" },
  { abbr: "NIFA",   def: "Nebraska Investment Finance Authority" },
  { abbr: "NPS",    def: "National Park Service" },
  { abbr: "NPPD",   def: "Nebraska Public Power District" },
  { abbr: "NRD",    def: "Natural Resources District" },
  { abbr: "NROC",   def: "Nebraska Regional Officials Council" },
  { abbr: "NSWERS", def: "Nebraska Statewide Workforce & Educational Reporting System" },
  { abbr: "NTIA",   def: "National Telecommunications and Information Administration" },
  { abbr: "PADD",   def: "Panhandle Area Development District" },
  { abbr: "PPHD",   def: "Panhandle Public Health District" },
  { abbr: "PREMA",  def: "Panhandle Rural Electric Membership Association" },
  { abbr: "QCEW",   def: "Quarterly Census of Employment and Wages" },
  { abbr: "REAP",   def: "Rural Enterprise Assistance Project" },
  { abbr: "SAIPE",  def: "Small Area Income and Poverty Estimates" },
  { abbr: "SBA",    def: "Small Business Administration" },
  { abbr: "SRF",    def: "State Revolving Fund" },
  { abbr: "STIP",   def: "Statewide Transportation Improvement Program" },
  { abbr: "TCD",    def: "Trusted Community Development" },
  { abbr: "USDA",   def: "United States Department of Agriculture" },
  { abbr: "WIOA",   def: "Workforce Innovation and Opportunity Act" },
  { abbr: "WNCC",   def: "Western Nebraska Community College" },
];

const COUNCIL = [
  "Valerie Beel",
  "Lisa Hutchinson",
  "Jordan Diedrich",
  "Dr. Andrew Dick",
  "Misty Curtis",
  "Scott Yates",
  "Dr. Derek Peil",
];

const BANNER_ESTIMATES = [
  ["Median Household Income", "$78,839", "± $13,607", "ACS 5-Year, 2020–2024"],
  ["Median Household Income (Prior Release)", "$71,250", "± $17,961", "ACS 5-Year, 2019–2023"],
  ["Median Household Income (Two Releases Prior)", "$62,375", "14.2% swing to next release", "ACS 5-Year, 2018–2022"],
  ["Per Capita Income", "$36,650", "± $4,207", "ACS 5-Year, 2023"],
  ["Poverty Rate (All Persons)", "9.4%", "± 5.9 pct pts", "ACS 5-Year, 2023"],
  ["Poverty Rate (Alt. Estimate)", "11.7%", "Diff. methodology", "NACO, 2023"],
  ["Total Population", "657", "~267 households", "Census PEP, 2023"],
];

const TABS = [
  { key: "a", label: "A · Data Sources" },
  { key: "b", label: "B · Strategy Council" },
  { key: "c", label: "C · Acronyms" },
  { key: "d", label: "D · E Pluribus Unum" },
];

// ─── Panels ──────────────────────────────────────────────────────────────────

function EPluribusUnum() {
  return (
    <>
      <h3>D. E Pluribus Unum</h3>
      <p className="chapter-lede">
        Out of Many, One: understanding data limitations in our most rural
        counties and the case for a Panhandle-wide economic lens.
      </p>

      <h4>The Challenge of Counting What Counts</h4>
      <p>
        Economic development strategy depends on accurate data. When we build
        investment cases, apply for federal grants, or set priorities for
        workforce development, we rely on published income, poverty, and
        employment statistics to tell us where need exists and where opportunity
        lies. Across much of the Nebraska Panhandle, those statistics do their
        job reasonably well. In our larger population centers (Scottsbluff,
        Gering, Sidney, Chadron) sample sizes are sufficient, margins of error
        are manageable, and the numbers generally reflect what residents
        experience on the ground.
      </p>
      <p>
        But as we move into the most sparsely populated corners of our
        eleven-county region, the data begin to falter not because the federal
        agencies producing them are doing poor work, but because the statistical
        tools available were never designed to provide pinpoint accuracy for
        communities measured in the hundreds rather than the thousands. The ACS,
        the BEA Regional Economic Information System, and even the model-based
        SAIPE program all face one constraint: when the universe of households
        is small enough, a handful of respondents can move the needle
        dramatically.
      </p>
      <p>
        This chapter examines that challenge head-on, using Banner County as a
        case study. Our purpose is not to discredit any single data source, but
        to demonstrate why responsible economic strategy in the Panhandle must
        look beyond any one county’s published figures and instead draw
        strength from a regional perspective.
      </p>

      <h4>Banner County: A Case Study in Statistical Volatility</h4>
      <p>
        <strong>The Published Numbers.</strong> Banner County sits in the western
        Panhandle between Scotts Bluff County and the Wyoming border. By almost
        any measure it is one of the most rural counties in Nebraska — a 2023
        population of approximately 657 persons in roughly 267 households, the
        87th most populated of Nebraska’s 93 counties. According to the Census
        Bureau’s most recent ACS 5-year estimate (2020–2024), Banner County’s
        median household income stands at $78,839, a figure that on its face
        suggests a community above the state median. The prior release
        (2019–2023) put it at $71,250, and the one before that (2018–2022) at
        $62,375: a climb of more than $16,000 across two releases in a county of
        roughly 267 households. But here the story gets complicated.
      </p>
      <p>
        <strong>The Margin of Error Problem.</strong> The Census Bureau, to its
        credit, publishes margins of error alongside its estimates. For Banner
        County, the 2019–2023 ACS 5-year median household income estimate of
        $71,250 carries a margin of error of <strong>±$17,961</strong>. With 90%
        confidence, the true median household income falls somewhere between
        roughly <strong>$53,289 and $89,211</strong> — a range spanning nearly
        $36,000. The margin of error alone is larger than the per capita income
        of many communities in our region. The published point estimate could
        just as easily be $55,000 or $87,000. We simply do not know with
        statistical precision. The current estimate is tighter but tells the
        same story: $78,839 ± $13,607. The two confidence ranges overlap almost
        entirely, so the apparent $7,600 gain between releases may be no gain at
        all.
      </p>
      <p>
        The poverty rate tells a similar story. Census Reporter lists Banner
        County’s poverty rate at 9.4% with a margin of error of ±5.9 percentage
        points; the Nebraska Association of County Officials reports 11.7% for
        the same year. These are not minor discrepancies — they represent
        fundamentally different pictures of economic well-being, and both fall
        within plausible statistical bounds.
      </p>

      <div className="table-wrapper">
        <table className="ceds-table">
          <thead>
            <tr>
              <th scope="col">Metric</th>
              <th scope="col">Estimate</th>
              <th scope="col">MOE / Note</th>
              <th scope="col">Source / Year</th>
            </tr>
          </thead>
          <tbody>
            {BANNER_ESTIMATES.map(([metric, est, moe, src]) => (
              <tr key={metric}>
                <td><strong>{metric}</strong></td>
                <td>{est}</td>
                <td>{moe}</td>
                <td>{src}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="table-note">
        Published income and poverty estimates for Banner County, NE. Note the
        magnitude of margins of error relative to point estimates.
      </p>

      <h4>Why Small Populations Produce Unreliable Estimates</h4>
      <p>
        The ACS samples roughly 3.5 million addresses nationwide each year. For
        a county of 267 households, the annual sample may include only a handful
        of respondents, sometimes fewer than ten. The 5-year pooled estimates
        improve this by aggregating five years of responses, but the effective
        sample for Banner County remains extremely small. In an agricultural
        county where farm proprietor income can vary enormously year to year
        (driven by commodity prices, drought, crop insurance payouts, and land
        sales) even the median is susceptible to distortion. If two or three
        sampled households happen to be operators of large irrigated farms who
        had a strong crop year, the published median shifts upward
        significantly; a sample capturing more retirees on fixed incomes would
        pull it down.
      </p>
      <p>
        This is not a flaw in the data, it is a mathematical reality. Small
        denominators produce large variance. The federal agencies understand
        this, which is why they publish margins of error. The challenge arises
        when downstream users (grant programs, eligibility formulas, investment
        models) treat the point estimates as precise truths.
      </p>

      <h4>What We Do Know About Banner County</h4>
      <p>
        Despite the noise in the headline numbers, several indicators paint a
        more grounded picture. <strong>Employment is concentrated and
        declining:</strong> of 326 employed residents, 116 (35.6%) work in
        agriculture, forestry, fishing, and hunting, and total employment fell
        6.3% between 2022 and 2023. <strong>Per capita income tells a humbler
        story:</strong> at $36,650, it is about 90% of the Nebraska average and
        85% of the national figure — a community getting by, not one that is
        affluent. <strong>A note on which “per capita income” we mean.</strong>{" "}
        This figure differs sharply from the $80,999 per capita{" "}
        <em>personal</em> income reported for Banner County in Chapter 2.3 — and
        intentionally so. The two series measure different things. BEA’s per
        capita personal income (Table CAINC1, used throughout Chapter 2.3)
        includes farm proprietor income, dividends, interest, rent, and
        government transfer payments, all divided across the county’s small
        population; in an agricultural county where a handful of large
        irrigated operations report a strong year, this aggregate can swing
        sharply upward. The ACS per capita income figure here reflects
        survey-reported wage and salary income and excludes most of that
        volatility. Both figures are correctly sourced and both are “true” —
        they simply answer different questions, and the gap between them
        ($80,999 vs. $36,650) is itself a data point about how concentrated and
        volatile Banner County’s income base is. This CEDS uses BEA PCPI for the
        regional and county comparisons in Chapter 2.3, because it is the series
        Nebraska’s own state and county figures are built on; it uses the ACS
        figure here only to illustrate the magnitude of divergence between
        methodologies in a county this small. <strong>The county’s own
        comprehensive plan</strong> acknowledges per capita income has
        consistently remained below the state average and that families in
        poverty rose 10.7% over thirty years. <strong>The population is aging
        and shrinking:</strong> a median age of 56.6 (roughly 1.5× the state’s
        37.1) and a 1.9% single-year decline do not align with a median
        household income that exceeds the state figure.
      </p>

      <h4>E Pluribus Unum: The Case for a Panhandle-Wide Lens</h4>
      <p>
        Banner County is not unique. Across the state, several counties face
        identical challenges: Arthur, McPherson, Garden, Grant, and others share
        very small populations, agricultural bases, and the resulting
        statistical instability. Any one could serve as a similar case study.
        This is precisely why PADD approaches economic strategy from a{" "}
        <strong>regional perspective</strong> rather than a county-by-county,
        number-by-number analysis. When we aggregate across our eleven counties,
        sample sizes become meaningful, margins of error narrow, trends become
        visible, and the noise that plagues any single small county dissolves
        into a clearer regional signal.
      </p>

      <h4>Our approach is built on several principles</h4>
      <ul className="ceds-list">
        <li>
          <strong>We triangulate across multiple data sources.</strong> We
          cross-reference ACS, SAIPE, BEA REIS, IRS Statistics of Income, USDA
          Census of Agriculture, Nebraska Department of Labor wage records, and
          Social Security data. Where these converge, we have confidence. Where
          they diverge, we investigate.
        </li>
        <li>
          <strong>We read the margins of error, not just the point
          estimates.</strong> Throughout this CEDS and in our grant
          applications, we report confidence intervals alongside point
          estimates for our smallest counties. When a margin of error exceeds
          20–25% of the estimate, we flag the figure as directionally
          informative rather than precisely descriptive.
        </li>
        <li>
          <strong>We invest in primary data collection where federal data falls
          short.</strong> For counties where published statistics are
          demonstrably unreliable, we conduct targeted income surveys, employer
          interviews, and community needs assessments that supplement — and
          sometimes correct — the federal numbers.
        </li>
        <li>
          <strong>We think regionally.</strong> Workforce, supply chains,
          healthcare access, and educational pipelines do not stop at county
          lines. A farmer in Banner County shops in Scottsbluff, sends children
          to school across multiple districts, and accesses care across county
          and state boundaries. When we invest in broadband, workforce training,
          or infrastructure, we do so understanding that lifting one community
          lifts its neighbors.
        </li>
      </ul>

      <h4>Conclusion: Honest Numbers, Honest Strategy</h4>
      <p>
        The motto E Pluribus Unum (out of many, one) captures both our challenge
        and our strength. Our many small communities, taken individually, are
        often too small for federal statistical machinery to measure with
        precision. But taken together, as a unified Panhandle region, they form
        a picture that is both statistically reliable and strategically
        actionable. We do not dismiss the published data for Banner County or
        any other county. We use it carefully, contextually, and in combination
        with everything else we know. We acknowledge its limitations openly
        because doing so is not a sign of weakness but of rigor, and we build
        our strategy on the broadest possible foundation of evidence, because
        the families and businesses across all eleven counties deserve nothing
        less.
      </p>
      <p className="source-note">
        Data sources referenced in this chapter: U.S. Census Bureau ACS 5-Year
        Estimates (2018–2022 through 2020–2024); Census Bureau SAIPE Program
        (2023); BEA REIS (2023); Census Reporter; Data USA; Nebraska Association
        of County Officials; Banner County Comprehensive Plan (Economy
        Section); USDA Economic Research Service County-Level Data Sets.
      </p>
    </>
  );
}

// ─── Component ───────────────────────────────────────────────────────────────

export default function AppendixReference() {
  const [activeTab, setActiveTab] = useState("a");
  const [acronymFilter, setAcronymFilter] = useState("");

  const filteredAcronyms = ACRONYMS.filter(
    (a) =>
      acronymFilter === "" ||
      a.abbr.toLowerCase().includes(acronymFilter.toLowerCase()) ||
      a.def.toLowerCase().includes(acronymFilter.toLowerCase())
  );

  return (
    <div className="chapter appendix">
      <div className="chapter-content">
        <h2>Appendices</h2>
        <p className="appendix-intro">
          Supporting reference materials for the 2026–2031 Panhandle Area
          Development District Comprehensive Economic Development Strategy.
        </p>

        {/* ── Tab bar ─────────────────────────────────────────── */}
        <div className="appendix-tabs" role="tablist" aria-label="Appendix sections">
          {TABS.map((t) => (
            <button
              key={t.key}
              role="tab"
              aria-selected={activeTab === t.key}
              aria-controls={`appendix-panel-${t.key}`}
              id={`appendix-tab-${t.key}`}
              className={`appendix-tab${activeTab === t.key ? " appendix-tab--active" : ""}`}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* ── Panel A: Data Sources ──────────────────────────── */}
        {activeTab === "a" && (
          <section
            role="tabpanel"
            id="appendix-panel-a"
            aria-labelledby="appendix-tab-a"
            className="appendix-panel"
          >
            <h3>A. Data Sources and References</h3>
            <p>
              The following primary data sources inform the analysis presented
              in this CEDS. Users seeking the most current data are encouraged
              to consult these sources directly, as figures may have been
              updated since the research period.
            </p>
            <div className="appendix-sources">
              {SOURCES.map((s, i) => (
                <div key={i} className="appendix-source-row">
                  <div className="appendix-source-agency">{s.agency}</div>
                  <div className="appendix-source-title">
                    {s.url ? (
                      <a
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="appendix-link"
                      >
                        {s.title}
                      </a>
                    ) : (
                      s.title
                    )}
                    {s.note && (
                      <span className="appendix-source-note"> — {s.note}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* ── Panel B: Strategy Council ─────────────────────── */}
        {activeTab === "b" && (
          <section
            role="tabpanel"
            id="appendix-panel-b"
            aria-labelledby="appendix-tab-b"
            className="appendix-panel"
          >
            <h3>B. CEDS Strategy Council</h3>
            <p>
              The CEDS Strategy Council serves as the standing body for annual
              CEDS review, performance monitoring, and strategy adaptation. Its
              role is to set benchmarks, open doors, validate results, and carry
              the story of this plan into the communities its members represent
              (not to re-plan the region).
            </p>
            <p>
              Members serve under the governance charter adopted in Year 1 under
              Objective 4.1.
            </p>
            <h4>Seated Council</h4>
            <ul className="people-list">
              {COUNCIL.map((n) => <li key={n}>{n}</li>)}
            </ul>
            <h4>Standing Charge</h4>
            <ul className="ceds-list">
              <li>Meet semiannually (minimum 2 times per year) per the Goal 4.1 governance framework.</li>
              <li>Review annual CEDS progress against the KPIs in Chapter 9 and approve the public-facing progress report.</li>
              <li>Validate baseline and target numbers set for each objective before they are published.</li>
              <li>Surface emerging threats and opportunities for the annual resilience review (Chapter 10.6).</li>
            </ul>
          </section>
        )}

        {/* ── Panel C: Acronyms ─────────────────────────────── */}
        {activeTab === "c" && (
          <section
            role="tabpanel"
            id="appendix-panel-c"
            aria-labelledby="appendix-tab-c"
            className="appendix-panel"
          >
            <h3>C. Definitions and Acronyms</h3>

            {/* Search filter */}
            <div className="appendix-search-wrap">
              <label htmlFor="acronym-search" className="appendix-search-label">
                Filter acronyms
              </label>
              <input
                id="acronym-search"
                type="search"
                className="appendix-search"
                placeholder="Search acronym or definition…"
                value={acronymFilter}
                onChange={(e) => setAcronymFilter(e.target.value)}
                aria-label="Filter acronyms by term or definition"
              />
            </div>

            <div className="table-wrapper">
              <table className="ceds-table">
                <thead>
                  <tr>
                    <th scope="col">Acronym</th>
                    <th scope="col">Definition</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAcronyms.length > 0 ? (
                    filteredAcronyms.map((a) => (
                      <tr key={a.abbr}>
                        <td>
                          <strong>{a.abbr}</strong>
                        </td>
                        <td>{a.def}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="appendix-no-results">
                        No matching acronyms found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <p className="table-note">
              {filteredAcronyms.length} of {ACRONYMS.length} entries shown.
            </p>
          </section>
        )}

        {/* ── Panel D: E Pluribus Unum ──────────────────────── */}
        {activeTab === "d" && (
          <section
            role="tabpanel"
            id="appendix-panel-d"
            aria-labelledby="appendix-tab-d"
            className="appendix-panel"
          >
            <EPluribusUnum />
          </section>
        )}
      </div>
    </div>
  );
}
